__turbopack_context__.v({
  "backHome": "wPAzeq_backHome",
  "bookCategory": "wPAzeq_bookCategory",
  "bookContainer": "wPAzeq_bookContainer",
  "bookImage": "wPAzeq_bookImage",
  "container": "wPAzeq_container",
  "header": "wPAzeq_header",
  "search": "wPAzeq_search",
  "searchBox": "wPAzeq_searchBox",
  "searchLabel": "wPAzeq_searchLabel",
  "subtitle": "wPAzeq_subtitle",
  "title": "wPAzeq_title",
});
